<div class="postnew" [class.postnew-compact]="appearance === 'compact'">
  <div class="postnew-media-container" *ngIf="clipType !== ClipType.Text">
    <div class="postnew-media postnew-media-audio" *ngIf="clipType === ClipType.Audio">
      <app-post-record-audio
        (fileRecorded)="addAudio($event)"
        (transcription)="transcription($event)"
      ></app-post-record-audio>
    </div>
    <div class="invalid-feedback postnew-missing-error" *ngIf="postForm.errors?.invalidAudio && ngForm.submitted" i18n>
      Please record an audio clip.
    </div>

    <div class="postnew-media postnew-media-video" *ngIf="clipType === ClipType.Video">
      <app-post-record-video
        [appearance]="appearance"
        (fileRecorded)="addVideo($event)"
        (thumbnailCreated)="addVideoThumbnail($event)"
        (transcription)="transcription($event)"
      ></app-post-record-video>
    </div>
    <div class="invalid-feedback postnew-missing-error" *ngIf="postForm.errors?.invalidVideo && ngForm.submitted" i18n>
      Please record a video clip.
    </div>
  </div>

  <div class="postnew-form-container">
    <form [formGroup]="postForm" #ngForm="ngForm" (ngSubmit)="submitForm(ngForm)" novalidate>
      <div class="mb-3">
        <textarea
          autosize
          [minRows]="1"
          [maxRows]="5"
          [class.is-invalid]="postForm.get('title').invalid && (postForm.get('title').dirty || ngForm.submitted)"
          [class.form-control-lg]="appearance === 'compact'"
          class="form-control"
          formControlName="title"
          id="title"
          name="title"
          style="resize: none; padding-bottom: 0"
          [placeholder]="titlePlaceholderText"
          autocomplete="off"
        ></textarea>
        <div class="invalid-feedback" i18n>Please enter a title.</div>
      </div>

      <div
        class="mb-3"
        *ngIf="
          !postForm.get('parentId').value && target !== 'AudioProfile' && target !== 'UserTestimonial' && !this.where
        "
      >
        <select
          class="form-select"
          [class.is-invalid]="postForm.errors?.invalidWhere && (postForm.get('where').dirty || ngForm.submitted)"
          formControlName="where"
          id="where"
          name="where"
          (change)="changeWhere()"
        >
          <option [ngValue]="null" i18n>Post to...</option>
          <option value="timeline" i18n>Timeline</option>
          <option value="myvideos" i18n>My Videos</option>
          <option *ngIf="hasFeature(Feature.Groups)" value="group" i18n>Group</option>
          <option *ngIf="hasFeature(Feature.Chat)" value="chat" i18n="@@chat">Chat</option>
        </select>
        <div class="invalid-feedback" i18n>Please choose where to post.</div>
      </div>

      <div class="mb-3" *ngIf="postForm.get('where').value === 'group' && !this.where">
        <select
          class="form-select"
          [class.is-invalid]="postForm.errors?.invalidGroup && (postForm.get('group').dirty || ngForm.submitted)"
          formControlName="group"
          id="group"
          name="group"
          [compareWith]="compareId"
        >
          <option [ngValue]="null" i18n>Choose group...</option>
          <option *ngFor="let groupOption of groups" [ngValue]="groupOption">{{ groupOption.name }}</option>
        </select>
        <div class="invalid-feedback" i18n>Please select a group.</div>
      </div>

      <div class="mb-3" *ngIf="postForm.get('where').value === 'chat' && !this.where">
        <select
          class="form-select"
          [class.is-invalid]="postForm.errors?.invalidChat && (postForm.get('chat').dirty || ngForm.submitted)"
          formControlName="chat"
          id="chat"
          name="chat"
          [compareWith]="compareId"
        >
          <option [ngValue]="null" i18n>Choose chat...</option>
          <option *ngFor="let chatOption of chats" [ngValue]="chatOption">{{ chatOption.username }}</option>
        </select>
        <div class="invalid-feedback" i18n>Please select a chat.</div>
      </div>

      <div
        class="mb-3"
        [hidden]="
          postForm.get('where').value !== 'timeline' || !compactReveal() || !categoriesLoaded || !categories.length
        "
      >
        <select class="form-select" formControlName="category" id="category" name="category">
          <option [ngValue]="null" i18n>No Category</option>
          <option *ngFor="let category of categories" [ngValue]="category.id">{{ category.fullName }}</option>
        </select>
      </div>

      <div class="postnew-attach" *ngIf="target !== 'AudioProfile' && target !== 'UserTestimonial' && compactReveal()">
        <div class="img-upload">
          <a href="javascript:void(0)" class="btn btn-outline-info"
            ><mdi name="Plus" size="16"></mdi> <span i18n>Image</span></a
          >
          <input
            #profileImageInput
            type="file"
            class="img-preview-upload"
            id="image"
            name="image"
            accept="image/jpeg"
            (change)="processFile(profileImageInput)"
            required
          />
        </div>
        &nbsp;
        <a (click)="addLink()" class="btn btn-outline-info"><mdi name="Plus" size="16"></mdi> <span i18n>Link</span></a>
      </div>

      <div class="mb-3" *ngIf="postForm.get('link').value">
        <div class="postnew-link">
          {{ postForm.get('link').value }}
          <div class="postnew-link-close" (click)="removeLink()">
            <mdi name="Close"></mdi>
          </div>
        </div>
      </div>

      <div class="mb-3" *ngIf="thumbnail || originalUrl">
        <div class="img-preview" [class.img-preview-image]="thumbnail || originalUrl">
          <img [src]="thumbnail || originalUrl ? (thumbnail ? thumbnail?.src : originalUrl) : ''" />

          <div>
            <div (click)="removeThumbnail()" class="img-preview-remove" *ngIf="thumbnail">
              <mdi name="Close"></mdi>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>

      <div class="postnew-actions" *ngIf="compactReveal()">
        <a class="btn btn-light" (click)="cancel()">{{ cancelButtonText }}</a
        >&nbsp;
        <button type="submit" class="btn btn-primary" i18n="@@saveChanges">Save Changes</button>
      </div>
    </form>
  </div>
</div>
